import React from 'react'
import"./AboutPhase2.css"
const AboutPhase2 = () => {
  return (
    <div className='AboutPhase2'>
        <h1 className="headtitle">Some inspiring words to describe yourself</h1>
        <p className="paraone">
        <p className="paraone">
<b>Resilient:</b> Able to bounce back from setbacks and challenges.<br></br>
<b>Driven:</b>Motivated and focused on achieving goals.<br></br>
 <b>Empathetic: </b>Understanding and compassionate towards others.<br></br>
 <b>Innovative:</b>Creative and resourceful in finding solutions.<br></br>
 <b>Passionate:</b>Enthusiastic and dedicated to what you believe in.<br></br>
<b>Adaptable: </b>Flexible and able to adjust to different situations.<br></br>
<b>Courageous:</b> Willing to take risks and face difficulties with bravery.<br></br>
<b>Persistent:</b> Determined and steadfast in pursuing your objectives.<br></br>
<b>Curious: </b>Eager to learn and explore new ideas and possibilities.<br></br>
10.<b>Optimistic: </b>Positive-minded and hopeful, even in challenging times.<br></br>

</p>
</p>
 
    </div>
  )
}

export default AboutPhase2